<div class="card-table-transport" *ngIf="rowTransportDetailsData.length">
  <nf-table-layout
    *nfLoader="loading"
    hideTitle
    hideSearch
    [autoResizeGrid]="false"
    [isSectionTitle]="false"
    [gridOptions]="gridOptionsTransportDetails"
    [data]="rowTransportDetailsData"
    hideClearAll
  >
  </nf-table-layout>
</div>
<hs-panel-card
  *ngIf="rowTransportDetailsData.length == 0"
  header="No Transports Available"
>
  <p>No Transports are available for selected account</p>
</hs-panel-card>
